export const tabs = {
  FORECAST: 'FORECAST',
  FORECASTCOST: 'FORECAST_COST_TO_COMPLETE',
  DAILYCOST: 'DAILYCOST',
  CLAIM: 'CLAIM',
  SUBCONTRACT: 'SUBCONTRACT',
  VARIATION_REGISTER: 'VARIATION_REGISTER',
  DASHBOARD: 'DASHBOARD',
  REPORT: 'REPORT',
  FILEMANAGER: 'FILEMANAGER',
  SITEDIARY: 'SITEDIARY',
  PRODUCTIONTRACKING: 'PRODUCTION_TRACKING',
  DAYWORK_DOCKET: 'DAYWORK_DOCKET',
  FORMS: 'FORMS',
};

export const pages = {
  TASKFORM: 'TASKFORM',
  FORECAST: 'FORECAST',
  FORECASTCOST: 'FORECASTCOST',
  DAILYCOST: 'DAILYCOST',
  CLAIMLIST: 'CLAIMLIST',
  ADDCLAIM: 'ADDCLAIM',
  SUBCONTRACT: 'SUBCONTRACT',
  REPORTLIST: 'REPORTLIST',
  ADDREPORT: 'ADDREPORT',
  FORMS: 'FORMS',
};

export const dashboardChartOptions = [
  { label: 'Bar', value: 'bar' },
  { label: 'Line', value: 'line' },
];

export const equipmentTableRowOptions = [
  { label: 'Accounting Code', name: 'costCode', value: '1' },
  { label: 'Brand', name: 'brand', value: '2' },
  { label: 'Model', name: 'model', value: '3' },
];

export const dayRateOptions = [
  { id: 'Day', name: 'Day' },
  { id: 'Hour', name: 'Hour' },
  { id: 'Item', name: 'Item' },
  { id: 'Each', name: 'Each' },
  { id: 'Lump Sum', name: 'Lump Sum' },
];

export const selectOptions = {
  state: [
    { value: '1', label: 'New South Wales' },
    { value: '2', label: 'Queensland' },
    { value: '3', label: 'South Australia' },
    { value: '4', label: 'Tasmania' },
    { value: '5', label: 'Victoria' },
    { value: '6', label: 'Western Australia' },
  ],
  type: [
    { value: '0', label: 'Civil' },
    { value: '1', label: 'Demolition' },
  ],
  status: [
    { value: '1', label: 'Active' },
    { value: '2', label: 'Inactive' },
    { value: '3', label: 'Completed' },
  ],
  risk: [
    { label: '1', value: '1' },
    { label: '2', value: '2' },
    { label: '3', value: '3' },
    { label: '4', value: '4' },
    { label: '5', value: '5' },
    { label: '6', value: '6' },
    { label: '7', value: '7' },
    { label: '8', value: '8' },
    { label: '9', value: '9' },
    { label: '10', value: '10' },
  ],
};

export const SPOTLIGHT_SOURCES = {
  FILE_MANAGER: 'file_manager',
  FILE_MANAGER_PROJECT: 'file_manager_project',
  SITE_DIARY: 'site_diary',
};
